module.exports = __webpack_public_path__ + "static/media/img-dentist-screen@3x.8d2fb10c.png";